import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, merge } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExpWinAccountabilityService } from './exp-win-accountability.service';

@Component({
  selector: 'app-exp-win-accountability',
  templateUrl: './exp-win-accountability.component.html',
  styleUrls: ['./exp-win-accountability.component.scss']
})
export class ExpWinAccountabilityComponent implements OnInit {

  constructor(private svc: ExpWinAccountabilityService, private router: Router ) { }

  vmExpWinSumDataView$: Observable<any>;
  vmAcknowledgedCountView$: Observable<any>;

  ngOnInit() {
    
    this.vmExpWinSumDataView$ = this.svc.getExpWinAccountabilityData();
    this.vmAcknowledgedCountView$ = this.svc.getExpWinAccountabilityAcknowledgedCountData();
  }

  showDetails(resId: string, auditLogId: string) {
    this.router.navigateByUrl("reservations/exp-win-accountability-detail/" + resId + "/" + auditLogId);
  };

  isNegitive(val: number): boolean {
    if (val < 0) {
      return true;
    } else {
     return false;
    }
   }
}

